module.exports = __webpack_public_path__ + "img/icon-enterprise-blue.e3aaa2e6.svg";